import { render } from "./Sidebyside.vue?vue&type=template&id=61947e80&lang=pug"
import script from "./Sidebyside.vue?vue&type=script&lang=js"
export * from "./Sidebyside.vue?vue&type=script&lang=js"

import "./Sidebyside.vue?vue&type=style&index=0&id=61947e80&lang=scss"

import exportComponent from "/schmetterlinge/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__